import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './User';

export interface AuthApi {
  user$: Observable<User | null>;
  login(email: string, password: string): Observable<User>;
  loginWithGoogle(): Observable<User>;
  logout(): Observable<void>;
}

export const AUTH_API = new InjectionToken<AuthApi>('AUTH_API');
